const $ = require('jquery');

module.exports = function () {
    const fps = 1000 / 60;
    const viewLength = 4;
    const $wrap = $(".js-slider__wrap");
    const item = ".js-slider__item";
    const $item = $wrap.find(item);
    let itemWidth = $item.first().outerWidth(true);

    init();

    function init(){
        setCss();
        duplicate();
        timer();
    }

    function duplicate(){
        const clone1 = $item.clone(true, true);
        const clone2 = $item.clone(true, true);
        $wrap.append(clone1).append(clone2);
    }

    function setCss(){
        $wrap.css({
            "left": - (itemWidth * viewLength)
        });
    }

    function timer(){
        setTimeout(()=>{
            let length = parseInt($wrap.css("left"), 10);

            if(length === -(itemWidth * (viewLength + 1))){
                length = -(itemWidth * viewLength);
            } else {
                length = length - 1;
           }
            $wrap.css({
                left: length
            })
            if(length === itemWidth * viewLength * 2){
                $wrap.append(
                    $wrap.find(item).first()
                );
            }

            $wrap.find(item).css({opacity: ""});
            $wrap.find(item + ":lt(4):gt(1)").css({opacity: 0.4});
            $wrap.find(item + ":lt(12):gt(8)").css({opacity: 0.4});
            timer();
        }, fps);
    }
}
